module.exports = __webpack_public_path__ + "img/down.f69f9742.svg";